import { useState } from "react"
import Navbar from "../components/Navbar"
import Hero from "../components/Hero"
import HowItWorks from "../components/HowItWorks"
import Features from "../components/Features"
import Faq from "../components/Faq"
import Footer from "../components/Footer"

export default function Landing() {
  const [showAnimation, setShowAnimation] = useState(() => {
    return false // !sessionStorage.getItem("hasSeenIntro") // temporarily disabled
  })

  const handleAnimationEnd = () => {
    sessionStorage.setItem("hasSeenIntro", "true")
    setShowAnimation(false)
  }

  if (showAnimation) {
    return (
      <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-white">
        <video
          className="h-full w-full object-cover"
          autoPlay
          muted
          playsInline
          onEnded={handleAnimationEnd}
        >
          <source src="/logo-animation.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <button
          onClick={handleAnimationEnd}
          className="absolute right-4 top-4 z-[1001] rounded bg-white/80 px-4 py-2 text-sm font-medium text-black shadow hover:bg-white"
        >
          Skip Intro
        </button>
      </div>
    )
  }

  return (
    <div className="landing-page">
      <a
        className="absolute left-4 top-[-48px] z-[100] bg-gold-500 px-5 py-3 text-ink-900 transition-[top] focus:top-4"
        href="#main"
      >
        Skip to content
      </a>
      <Navbar />
      <main id="main">
        <Hero />
        <HowItWorks />
        <Features />
        <Faq />
      </main>
      <Footer />
    </div>
  )
}
